import React from 'react';
import cx from 'classnames';
import styles from './Button.module.css';

interface Props {
  children: React.ReactNode;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  size?: string;
  resetClass?: boolean;
}
export const TransparentOutlineButton = ({
  children,
  disabled = false,
  type = 'button',
  onClick,
  className,
  size,
  resetClass,
  ...props
}: Props) => {
  const defaultClasses = resetClass ? '' : 'f13 fw7 ttu br3 w-100 pointer bg-transparent';
  const buttonClasses = cx(
    defaultClasses,
    {
      'white ba b--white bw1 pointer': !disabled,
      'boulder bg-alto b--alto ba bw1 not-allowed': disabled,
      pv12: !size,
      pv8: size === 'medium',
      [styles.h40]: size === 'medium',
      [styles.pv10]: disabled,
    },
    className,
  );
  return (
    <button className={buttonClasses} disabled={disabled} type={type} onClick={onClick} {...props}>
      {children}
    </button>
  );
};
